export default "__VITE_ASSET__f060b6b8__"